import { Injectable } from '@angular/core';
import { INavigationTreenode } from 'src/app/types/infrastructure/interfaces/INavigationTreenode';

@Injectable({
  providedIn: 'root'
})
export class TreeService {

  constructor() { 
    
  }

  transformTreenodeData(node: INavigationTreenode, level: number) {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      treeview: node.treeview,
      value: node.value
    };
  };
}
